var ElementQueries = /** @class */ (function () {
    function ElementQueries() {
        this.elementQueries = [];
        this.running = false;
        this.MAX_ITERATIONS = 10;
    }
    ElementQueries.prototype.start = function () {
        var _this = this;
        this.__windowListener = function () {
            _this.notifyChange();
        };
        window.addEventListener('resize', this.__windowListener);
    };
    ElementQueries.prototype.stop = function () {
        window.removeEventListener('resize', this.__windowListener);
    };
    ElementQueries.prototype.addElementQuery = function (elementQuery) {
        if (this.elementQueries.length === 0) {
            this.start();
        }
        this.elementQueries.push(elementQuery);
        this.notifyChange(true);
    };
    ElementQueries.prototype.removeElementQuery = function (elementQuery) {
        var index = this.elementQueries.indexOf(elementQuery);
        if (index >= 0) {
            this.elementQueries.splice(index, 1);
            if (this.elementQueries.length === 0) {
                this.stop();
            }
        }
        this.notifyChange(true);
    };
    ElementQueries.prototype.notifyChange = function (callImmediately) {
        var _this = this;
        if (callImmediately === void 0) { callImmediately = false; }
        if (this.running) {
            return;
        }
        this.running = true;
        if (callImmediately) {
            this.__callElementQueries();
        }
        else {
            this.requestAnimationFrame(function () {
                _this.__callElementQueries();
            });
        }
    };
    ElementQueries.prototype.requestAnimationFrame = function (callback) {
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(callback);
        }
        else {
            // Fallback for old browsers not supporting requestAnimationFrame
            setTimeout(callback, 66);
        }
    };
    ElementQueries.prototype.__callElementQueries = function () {
        var counter = 0, rerun = true;
        // Similar stabilization strategy as Angular digest loop.
        // Invoking a elementQuery can cause another layout change that previous elementQuery
        // execution could not take into account.
        // When a elementQuery causes a layout change it has to return true, so that we know that the loop has to be rerun.
        // In order to avoid infinite loops we limit the reruns to this.MAX_ITERATIONS
        while (counter < this.MAX_ITERATIONS && rerun) {
            // Because of rendering optimization read and apply phases are performed in batch
            var readPhaseResults = this.elementQueries.map(function (elementQuery) { return ({
                readResult: elementQuery.read(),
                elementQuery: elementQuery
            }); });
            rerun = readPhaseResults.reduce(function (hasChanged, _a) {
                var readResult = _a.readResult, elementQuery = _a.elementQuery;
                return elementQuery.apply(readResult) || hasChanged;
            }, false);
            // Small optimization. Do not rerun if only one elementQuery is registered.
            rerun = rerun && this.elementQueries.length > 1;
            counter++;
        }
        this.running = false;
    };
    return ElementQueries;
}());
export { ElementQueries };
var elementQueries = new ElementQueries();
export { elementQueries };
export default elementQueries;
//# sourceMappingURL=elementQueries.js.map